import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { editPublicacion } from '../../../../actions/publicacionesActions';

const Entrega = ({ inCreate }) => {
    const publicacion = useSelector(state => state.publicaciones.publicacion);
    const userType = useSelector(state => state.general.userType);
    const dispatch = useDispatch();

    useEffect(() => {
        if (inCreate && !publicacion.zonasEnvioGratis) {
            dispatch(editPublicacion({
                ...publicacion,
                zonasEnvioGratis: {
                    amba: true,
                    interior: true,
                    patagonia: true
                }
            }));
        }
    }, [inCreate, publicacion, dispatch]);

    const handleChange = (event) => {
        const { name, checked } = event.target;
        const updated = { ...publicacion };
        const zonas = ['amba', 'interior', 'patagonia'];

        if (zonas.includes(name)) {
            updated.zonasEnvioGratis = {
                ...(publicacion.zonasEnvioGratis || {}),
                [name]: checked
            };
        } else {
            switch (name) {
                case 'envioPropio':
                case 'envioGratis':
                    updated[name] = checked;
                    break;
                case 'envioDomicilio':
                    updated.envioDomicilio = checked;
                    if (checked) updated.retiroSucursalMegatone = false;
                    break;
                case 'retiroSucursalMegatone':
                    updated.retiroSucursalMegatone = checked;
                    if (checked) updated.envioDomicilio = false;
                    break;
                default:
                    break;
            }
        }

        dispatch(editPublicacion(updated));
    };

    return (
        <div className="tab-pane p-20 active" id="home2" role="tabpanel">
            <div className="row form-group d-flex flex-wrap gap-3">

                {/* Tipo de Entrega */}
                <div className="col-md-5 p-3 border rounded bg-light">
                    <h5 className="fw-bold">Tipo de Entrega</h5>
                    <div className="d-flex flex-column">
                        <div className="row ms-1">
                            <div className="col-12 my-1">
                                <input
                                    id="envioDomicilio"
                                    type="checkbox"
                                    className="me-2"
                                    checked
                                    disabled
                                />
                                <label htmlFor="envioDomicilio">Envío a domicilio</label>
                            </div>
                            <div className="col-12 my-1">
                                <input
                                    type="checkbox"
                                    id="sucursalMegatone"
                                    className="me-2"
                                    disabled
                                />
                                <label htmlFor="sucursalMegatone">Retiro sucursal de Megatone</label>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    );
};

export default Entrega;
